export { default } from './RectangleStar'
